import { useQuery } from "@apollo/client";
import { GET_ADVERTISE_BANNERS } from "./queries";
import { AdvertiseBannersResponse } from "./types";

export const useAdvertiseBanners = () => {
  const { data, loading, error } = useQuery<AdvertiseBannersResponse>(
    GET_ADVERTISE_BANNERS,
    {
      // Poll every 5 minutes to get fresh data
      pollInterval: 5 * 60 * 1000,
      // Don't show errors to users, just silently fail
      errorPolicy: "ignore",
    }
  );

  return {
    banners: data?.advertiseBanners || [],
    loading,
    error,
  };
};
